import notificationsStore from '@store/notificationsStore';
import { InAppNotificationSocketEnum } from '@source/utils/enums';
import { useEffect, useRef } from 'react';
import io, { Socket } from "socket.io-client";
import { URL } from '@source/hooks/useSocketHome';

export default function useSocketInAppNotifications(): [() => void] {
  const socketRef = useRef<Socket | null>(null)

  useEffect(() => {
    socketRef.current = io(URL as string, { path: "/api/websocket/in-app-notifications", auth: {
      token: `Bearer ${localStorage.getItem('accessToken')}`
    }});

    socketRef.current.onAny((event: InAppNotificationSocketEnum, data) => {
      if (event === InAppNotificationSocketEnum.SUCCESSFULLY_CONNECT || event === InAppNotificationSocketEnum.NEW_NOTIFICATION) {
        if (typeof data?.count === 'number') {
          notificationsStore.setUnreadCount(data.count);
        }
      }
    });

    socketRef.current.on(InAppNotificationSocketEnum.ERROR, (data) => { console.log('error', data) });

    return () => {
      socketRef.current?.disconnect()
    }
  }, [])

  const onInAppNotifications = () => {
    socketRef.current?.emit(InAppNotificationSocketEnum.CONNECT)
  }

  return [onInAppNotifications];
}
